export default "__VITE_ASSET__g0itXJSK__"